import React from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'

export default function PlaylistDescriptionTextField() {
  const [t] = useTranslation()
  return <FormTextField label={t('playlists.form.description.label', 'Description')} name="description" />
}
